"use client";

import { Icon } from "@iconify/react/dist/iconify.js";

interface IAppDownloadButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    type?: "google" | "apple" | "amazon" | undefined;
    size?: "xs" | "sm" | "md" | "lg" | undefined;
    href?: string;
    title?: string;
}

interface IStoreItem {
    sub: string;
    name: string;
    icon: string;
    title: string;
    href: string;
}

interface IStore {
    [name:string]: IStoreItem;
}

export default function AppDownloadButton (props: IAppDownloadButtonProps) {
    const { href, type="google", size="md", title } = props;

    const stores: IStore = {
        google: {
            sub: "GET IT ON",
            name: "Google Play",
            icon: "logos:google-play-icon",
            title: "Daily task earn money in Nigeria - Download Enanpay app on Google Play",
            href: "https://play.google.com/store/apps/details?id=com.enanpay.mobile",
        },
        apple: {
            sub: "Download on the",
            name: "Apple Store",
            icon: "tdesign:logo-apple-filled",
            title: "Daily task earn money in Nigeria - Download Enanpay app on the App Store",
            href: "https://apps.apple.com/us/app/enanpay/id6753994100",
        },
    }

    const btnSize = !!size? `size-${size}` : "";

    return (
        <a 
            {...props}
            href={href ?? stores[type].href}
            className={`btn-app-download ${btnSize}`}
            title={title ?? stores[type].title}
            target="_blank" 
            rel="noopener noreferrer" 
        >
            <Icon icon={stores[type].icon} className="icon" />
            <div>
                <h2 className="sub">{ stores[type].sub }</h2>
                <h2 className="title">{ stores[type].name }</h2>
            </div>
        </a>
    );
}